import { GridLayout } from "@lib/titan2/dist/game/control/layout/GridLayout";
import { ButtonProperties } from "@lib/titan2/dist/game/control/properties/ButtonProperties";
import { PanelProperties } from "@lib/titan2/dist/game/control/properties/PanelProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
import { FontStyle } from "../style/FontStyle";
import { SlingoStyle } from "../style/SlingoStyle";
/**
 * AbstractTestDisplayProperties.ts
 */
export class AbstractTestDisplayProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.testButtonProperties.equals(other.testButtonProperties) &&
            this.panelProperties.equals(other.panelProperties);
    }
    setDefaultValues() {
        this.testButtonProperties = new ButtonProperties(SlingoStyle.TEST_BUTTON, SlingoStyle.MODULE);
        this.testButtonProperties.textFieldProperties = new TextFieldProperties(FontStyle.TEST_BUTTON);
        this.panelProperties = new PanelProperties();
        this.panelProperties.layout = new GridLayout(2, 8, 5, 5);
    }
}
//# sourceMappingURL=AbstractTestDisplayProperties.js.map